import { useState, useEffect } from 'react'
import { ProductLine } from '@adc/constants'
import configment from '@adc/configment'

/**
 * This is needed as we are not 100% correlating host with theme yet.  For example, we have pages on auction.com that
 * are themed as smartsale.  This is a temporary solution until we can get the host to theme correlation in place,
 * at which point we can just use theme.
 */
const useProductLineFromHost = () => {
  const [productLine, setProductLine] = useState<ProductLine | null>(null)

  useEffect(() => {
    const determineProductLine = () => {
      if (configment.get('AUCTIONCOM_HOST', '') === window.origin) {
        return ProductLine.AuctionCom
      }
      if (configment.get('SMARTSALE_HOST', '') === window.origin) {
        return ProductLine.SmartSale
      }
      // TODO: add morpheus
      return null
    }

    setProductLine(determineProductLine())
  }, [])

  return productLine
}

export default useProductLineFromHost
